import { render, staticRenderFns } from "./PanelGroup.vue?vue&type=template&id=8a059ed8&scoped=true&"
import script from "./PanelGroup.vue?vue&type=script&lang=js&"
export * from "./PanelGroup.vue?vue&type=script&lang=js&"
import style0 from "./PanelGroup.vue?vue&type=style&index=0&id=8a059ed8&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a059ed8",
  null
  
)

component.options.__file = "PanelGroup.vue"
export default component.exports